import React, { lazy, Suspense } from "react";
const _ReportsAdmin = lazy(() =>
  import("../../features/reports/components/_ReportsAdmin"),
);
import Loading from "../../components/ui/Suspense";
const _Reports = () => {
  return (
    <Suspense fallback={<Loading />}>
      <_ReportsAdmin />
    </Suspense>
  );
};

export default _Reports;
